export const INCLUDED_SERVICE_OPTIONS = [
    { label: "Skylift", value: "Skylift Rental" },
    { label: "Downlight", value: "Downlight Package" },
    { label: "Dismantle", value: "Dismantle Old Awning" },
    { label: "Crane", value: "Crane Rental" },
    { label: "Rubbish", value: "Rubbish Bin Rental" },
];

const getSelectedServices = (value) => {
    const lines = String(value || "")
        .split(/\r\n|\r|\n/)
        .map((line) => line.trim().toLowerCase());
    return INCLUDED_SERVICE_OPTIONS.filter(
        (option) =>
            lines.includes(option.value.toLowerCase()) ||
            lines.includes(option.label.toLowerCase())
    ).map((option) => option.label);
};

export default function IncludedServicesField({ label, value, onChange, className = "" }) {
    const selected = getSelectedServices(value);

    const toggleService = (service) => {
        const next = selected.includes(service)
            ? selected.filter((item) => item !== service)
            : [...selected, service];
        onChange(
            INCLUDED_SERVICE_OPTIONS.filter((option) => next.includes(option.label))
                .map((option) => option.value)
                .join("\n")
        );
    };

    return (
        <div className={`addProductItem remarkField ${className}`.trim()}>
            {label}
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                {INCLUDED_SERVICE_OPTIONS.map(({ label: service }) => {
                    const checked = selected.includes(service);
                    return (
                        <label
                            key={service}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                                margin: 0,
                                padding: "8px 14px",
                                borderRadius: "9999px",
                                border: `1.5px solid ${checked ? "#f97316" : "#e5e7eb"}`,
                                background: checked ? "#fff7ed" : "#f9fafb",
                                color: checked ? "#c2410c" : "#374151",
                                fontWeight: 600,
                                fontSize: "14px",
                                cursor: "pointer",
                                userSelect: "none",
                                transition: "all 0.15s ease",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={() => toggleService(service)}
                                style={{
                                    width: "16px",
                                    height: "16px",
                                    padding: 0,
                                    margin: 0,
                                    accentColor: "#f97316",
                                    cursor: "pointer",
                                }}
                            />
                            {service}
                        </label>
                    );
                })}
            </div>
        </div>
    );
}
